import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationEn from "@/locales/en/translation.json";
import translationEs from "@/locales/es/translation.json";
import translationPt from "@/locales/pt/translation.json";
import translationPtBR from "@/locales/pt-BR/translation.json";

/** Idiomas disponíveis no switch da navbar (rótulos curtos). */
export const LANGUAGE_OPTIONS = [
  { code: "pt-BR", label: "PT-BR" },
  { code: "pt", label: "PT" },
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
] as const;

const supportedLngs = LANGUAGE_OPTIONS.map(o => o.code);

const resources = {
  "pt-BR": { translation: translationPtBR },
  pt: { translation: translationPt },
  en: { translation: translationEn },
  es: { translation: translationEs },
} as const;

function syncDocumentLanguage(lng: string) {
  if (typeof document === "undefined") return;
  document.documentElement.lang = lng;
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "pt-BR",
    supportedLngs: [...supportedLngs],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "i18nextLng",
    },
  });

syncDocumentLanguage(i18n.resolvedLanguage ?? i18n.language);
i18n.on("languageChanged", syncDocumentLanguage);

export { i18n };
